// Mock data for Trip Memories feature
// This will be replaced with API calls in Phase 2

export const mockTrips = [
    { id: 101, name: 'Paris Adventure', startDate: '2025-03-15', endDate: '2025-03-20' },
    { id: 102, name: 'Tokyo Discovery', startDate: '2025-04-01', endDate: '2025-04-10' },
    { id: 103, name: 'NYC Weekend', startDate: '2025-02-14', endDate: '2025-02-17' },
];

export const mockDays = {
    101: [ // Paris Adventure
        { id: 1, tripId: 101, date: '2025-03-15', title: 'Arrival in Paris', order: 0 },
        { id: 2, tripId: 101, date: '2025-03-16', title: 'Eiffel Tower & Louvre', order: 1 },
        { id: 3, tripId: 101, date: '2025-03-17', title: 'Montmartre & Sacré-Cœur', order: 2 },
        { id: 4, tripId: 101, date: '2025-03-18', title: 'Versailles Day Trip', order: 3 },
        { id: 5, tripId: 101, date: '2025-03-19', title: 'Seine Cruise & Shopping', order: 4 },
        { id: 6, tripId: 101, date: '2025-03-20', title: 'Departure Day', order: 5 },
    ],
    102: [ // Tokyo Discovery
        { id: 7, tripId: 102, date: '2025-04-01', title: 'Landing in Tokyo', order: 0 },
        { id: 8, tripId: 102, date: '2025-04-02', title: 'Shibuya & Harajuku', order: 1 },
        { id: 9, tripId: 102, date: '2025-04-03', title: 'Senso-ji Temple & Asakusa', order: 2 },
        { id: 10, tripId: 102, date: '2025-04-04', title: 'Mt. Fuji Day Trip', order: 3 },
    ],
    103: [ // NYC Weekend
        { id: 11, tripId: 103, date: '2025-02-14', title: 'Valentine\'s in NYC', order: 0 },
        { id: 12, tripId: 103, date: '2025-02-15', title: 'Central Park & Museums', order: 1 },
        { id: 13, tripId: 103, date: '2025-02-16', title: 'Broadway Night', order: 2 },
    ],
};

export const mockActivities = {
    1: [ // Day 1 - Paris Arrival
        { id: 1, dayId: 1, name: 'Airport Transfer', type: 'transport', time: '14:00' },
        { id: 2, dayId: 1, name: 'Check-in at Hotel', type: 'accommodation', time: '16:00' },
        { id: 3, dayId: 1, name: 'Walk along Champs-Élysées', type: 'activity', time: '18:00' },
        { id: 4, dayId: 1, name: 'Dinner at Le Petit Cler', type: 'food', time: '19:30' },
    ],
    2: [ // Day 2 - Eiffel Tower
        { id: 5, dayId: 2, name: 'Morning at Eiffel Tower', type: 'activity', time: '09:00' },
        { id: 6, dayId: 2, name: 'Lunch at Café de Flore', type: 'food', time: '12:30' },
        { id: 7, dayId: 2, name: 'Louvre Museum Visit', type: 'activity', time: '14:00' },
        { id: 8, dayId: 2, name: 'Dinner Cruise on Seine', type: 'food', time: '20:00' },
    ],
    3: [ // Day 3 - Montmartre
        { id: 9, dayId: 3, name: 'Sacré-Cœur Basilica', type: 'activity', time: '10:00' },
        { id: 10, dayId: 3, name: 'Artist Square at Place du Tertre', type: 'activity', time: '11:30' },
        { id: 11, dayId: 3, name: 'Lunch at Pink Mamma', type: 'food', time: '13:00' },
    ],
};

export const mockDayNotes = {
    1: "First day in Paris! The flight was long but worth it. The city is even more beautiful than I imagined. The evening stroll along Champs-Élysées was magical with all the lights.",
    2: "What an incredible day! Seeing the Eiffel Tower in person gave me chills. The Louvre was overwhelming - we could spend a week there. The dinner cruise was the highlight!",
    3: "Montmartre has such a unique vibe. Watching the artists paint in Place du Tertre was fascinating. Got a portrait done as a souvenir!",
    11: "Valentine's Day in New York! Times Square at night was unreal. Had the most romantic dinner overlooking the city skyline.",
};

export const mockMemories = {
    // Day 1 - Paris Arrival
    1: [
        {
            id: 'm1',
            dayId: 1,
            activityId: 3,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=300',
            caption: 'First glimpse of the Champs-Élysées',
            takenAt: '2025-03-15T18:30:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 0,
        },
        {
            id: 'm2',
            dayId: 1,
            activityId: 4,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=300',
            caption: 'Amazing French cuisine!',
            takenAt: '2025-03-15T20:00:00',
            isHighlight: false,
            privacyLevel: 'private',
            sortOrder: 1,
        },
    ],
    // Day 2 - Eiffel Tower
    2: [
        {
            id: 'm3',
            dayId: 2,
            activityId: 5,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1511739001486-6bfe10ce65f4?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1511739001486-6bfe10ce65f4?w=300',
            caption: 'The iconic Eiffel Tower at sunrise',
            takenAt: '2025-03-16T09:15:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 0,
        },
        {
            id: 'm4',
            dayId: 2,
            activityId: 5,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1431274172761-fca41d930114?w=300',
            caption: 'View from the top!',
            takenAt: '2025-03-16T10:30:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 1,
        },
        {
            id: 'm5',
            dayId: 2,
            activityId: 7,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=300',
            caption: 'Inside the Louvre',
            takenAt: '2025-03-16T15:00:00',
            isHighlight: false,
            privacyLevel: 'private',
            sortOrder: 2,
        },
        {
            id: 'm6',
            dayId: 2,
            activityId: 7,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1541264161754-445bbdd7de52?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1541264161754-445bbdd7de52?w=300',
            caption: 'Mona Lisa!',
            takenAt: '2025-03-16T15:45:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 3,
        },
        {
            id: 'm7',
            dayId: 2,
            activityId: 8,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1520939817895-060bdaf4fe1b?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1520939817895-060bdaf4fe1b?w=300',
            caption: 'Seine dinner cruise - unforgettable!',
            takenAt: '2025-03-16T21:00:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 4,
        },
    ],
    // Day 3 - Montmartre
    3: [
        {
            id: 'm8',
            dayId: 3,
            activityId: 9,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1550340499-a6c60fc8287c?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1550340499-a6c60fc8287c?w=300',
            caption: 'Sacré-Cœur Basilica',
            takenAt: '2025-03-17T10:30:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 0,
        },
        {
            id: 'm9',
            dayId: 3,
            activityId: 10,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1518656306295-aa28b28b2504?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1518656306295-aa28b28b2504?w=300',
            caption: 'Street artists in Montmartre',
            takenAt: '2025-03-17T12:00:00',
            isHighlight: false,
            privacyLevel: 'private',
            sortOrder: 1,
        },
    ],
    // NYC Valentine's (Day 11)
    11: [
        {
            id: 'm10',
            dayId: 11,
            activityId: null,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=300',
            caption: 'Times Square on Valentine\'s Day',
            takenAt: '2025-02-14T20:00:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 0,
        },
        {
            id: 'm11',
            dayId: 11,
            activityId: null,
            mediaType: 'image',
            mediaPath: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=800',
            thumbnail: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=300',
            caption: 'NYC skyline at night',
            takenAt: '2025-02-14T22:00:00',
            isHighlight: true,
            privacyLevel: 'private',
            sortOrder: 1,
        },
    ],
};

// Helper functions to work with mock data
export const getMemoriesForTrip = (tripId) => {
    const tripDays = mockDays[tripId] || [];
    const memories = [];
    tripDays.forEach(day => {
        const dayMemories = mockMemories[day.id] || [];
        memories.push(...dayMemories);
    });
    return memories;
};

export const getHighlightsForTrip = (tripId) => {
    return getMemoriesForTrip(tripId).filter(m => m.isHighlight);
};

export const getMemoriesForDay = (dayId) => {
    return mockMemories[dayId] || [];
};

export const getDayNote = (dayId) => {
    return mockDayNotes[dayId] || '';
};

export const getActivitiesForDay = (dayId) => {
    return mockActivities[dayId] || [];
};

export const getDaysForTrip = (tripId) => {
    return mockDays[tripId] || [];
};

export const getTripById = (tripId) => {
    return mockTrips.find(t => t.id === Number(tripId));
};
